(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.showlist = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "binge":"binge"
             ,"all_kids_shows":"all_kids_shows"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        binge:function(){
	        var id=1;
	        APPS.showlist.show.show(id);
        }
        ,all_kids_shows:function(id){
	        var id=5;
	        APPS.showlist.show.show(id);
        }
    }
    
    /*================================================================================
		Event Handlers
	 ================================================================================*/       
        
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();

